// client/src/hooks/useNotaFiscal.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/api';
import useAlert from './useAlert';

const errMsg = (err, fallback) => err.response?.data?.error || err.response?.data?.message || fallback;

// ---------------------------------------------------------------------
// Config (por Conta)
// ---------------------------------------------------------------------

export const useNotaFiscalConfig = () => useQuery({
    queryKey: ['nota-fiscal', 'config'],
    queryFn: () => apiClient.get('/notas-fiscais/config').then((r) => r.data.data),
});

export const useSalvarNotaFiscalConfig = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: (payload) => apiClient.put('/notas-fiscais/config', payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['nota-fiscal', 'config'] });
            setAlert('Configuração de nota fiscal salva com sucesso.', 'success');
        },
        onError: (err) => setAlert(errMsg(err, 'Erro ao salvar configuração de nota fiscal.'), 'danger'),
    });
};

// ---------------------------------------------------------------------
// Notas emitidas
// ---------------------------------------------------------------------

export const useNotasFiscais = (params = {}) => useQuery({
    queryKey: ['nota-fiscal', 'lista', params],
    queryFn: () => apiClient.get('/notas-fiscais', { params }).then((r) => r.data),
    placeholderData: (prev) => prev,
});

export const useReemitirNotaFiscal = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: (id) => apiClient.post(`/notas-fiscais/${id}/reemitir`),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['nota-fiscal', 'lista'] });
            setAlert('Reemissão disparada.', 'success');
        },
        onError: (err) => setAlert(errMsg(err, 'Erro ao reemitir nota fiscal.'), 'danger'),
    });
};

export const useConsultarStatusNotaFiscal = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: (id) => apiClient.post(`/notas-fiscais/${id}/consultar-status`),
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['nota-fiscal', 'lista'] });
            setAlert(`Status atualizado: ${res.data.data.status}.`, 'success');
        },
        onError: (err) => setAlert(errMsg(err, 'Erro ao consultar status junto ao provedor.'), 'danger'),
    });
};
